import React from 'react'

export const SalesCustom = ({ resPacket }) => {
  return (
    <div className="customTable" id="scroll">
      <table className="customTable w-100">
        <thead className="fixed-thead">
          <tr>
            <td>Date</td>
            <td>Month</td>
            <td>Year</td>
            <td>City/State</td>
            <td>Sales Person Name</td>
            <td>Customer Name</td>
            <td>State</td>
            <td>Invoice No</td>
            <td>Item Name</td>
            <td>Qty</td>
            <td>Unit of Measurement (UOM)</td>
            <td>Rate</td>
            <td>Discounted Price</td>
            <td>Category</td>
            <td>Sub Category</td>
            <td>Tax</td>
            <td>Total</td>
          </tr>
        </thead>
        <tbody className="body-scroll-custom">
          {
            resPacket && resPacket.map((sale, i) => {
              return <tr key={i}>
                <td>{sale.day}</td>
                <td>{sale.month}</td>
                <td>{sale.year}</td>
                <td>{sale.cityName}</td>
                <td>{sale.salesPersonName}</td>
                <td>{sale.customerName}</td>
                <td>{sale.state}</td>
                <td>{sale.invoiceNo}</td>
                <td>{sale.itemName}</td>
                <td>{sale.quantity}</td>
                <td>{sale.unitOfMeasurement}</td>
                <td>{sale.rate}</td>
                <td>{sale.discountPrice}</td>
                <td>{sale.categoryTitle}</td>
                <td>{sale.subCategoryTitle}</td>
                <td>{sale.tax}</td>
                <td>{parseFloat(sale.rate * sale.quantity).toFixed(2)}</td>
              </tr>
            })
          }

        </tbody>
      </table>


    </div>
  )
}
